<template>
  <div>
    <b-row v-if="breadcrumbs.length" class="breadcrumb-with-ctx-menu no-gutters">
      <b-col cols="8">
        <b-breadcrumb :items="breadcrumbs" />
      </b-col>
      <b-col cols="4" class="d-flex justify-content-end align-items-center pr-3">
        <font-awesome-icon
          v-if="$route.meta.contextMenu"
          icon="ellipsis-v"
          class="cursor-pointer"
          @click="contextMenuBtnClicked"
        />
      </b-col>
    </b-row>
    <component
      v-if="$route.meta.contextMenu"
      :is="$route.meta.contextMenu"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import eventBus from '@/components/utils/slideout-panel/eventBus';

export default {
  data() {
    return {
      showContextMenu: false,
    };
  },
  computed: {
    ...mapState('breadcrumb', [
      'breadcrumbs',
    ]),
  },
  methods: {
    contextMenuBtnClicked() {
      eventBus.$emit('toggleContextMenu');
    },
  },
};
</script>

<style scoped>
</style>
